







"use strict";

const httpUtil = require("common-util/browser/http-util.js");
const XuxTableSupport = require("common-util/browser/xux-table-support.js");
const {WebStorageManager} = require("common-util/browser/webstorage-util.js");
const storage = new WebStorageManager();
const app = require("./app-common.js");
const order = require("./order.js");
const Util = require("./util");
const util = new Util();

app.init(true);

app.ready(() => {
    util.afterLoginApply(app, order, "remote");
    util.logOutHeader(app);
    util.initSupportMenu(app);
    util.initLogoutMenu(app);
    let table = $("#remote-table");
    function deleteRemote(context) {
        let title = window.localizedTextMessages.instruction.title.cancel;
        let message = window.localizedTextMessages.instruction.warn.cancel;
        let messageDown = window.localizedTextMessages.instruction.warn.cancelNotice;
        util.messageAlertTable({
            title,
            width: "wide",
            message,
            messageDown,
            yesBtnMsg: window.localizedTextMessages.com.btn.yes,
            noBtnMsg: window.localizedTextMessages.com.btn.no,
            data: [{
                issueDate: context.element.find("td:first").text(),
                instructionContent: context.element.find("td:eq(1)").text(),
                instruction: context.element.find("td:eq(2)").text(),
                issuer: context.element.find("td:eq(3)").text()
            }],
            thead: ["instruction.label.issueDate", "instruction.label.instruction", "instruction.label.issuedTo", "instruction.label.issuedBy"],
            tbody(data) {
                let tr = "<tr><td><div>" + util.text(data.issueDate) + "</div></td><td><div>" + util.text(data.instructionContent) + "</div></td><td><div>"
                    + util.text(data.instruction) + "</div></td><td><div>" + util.text(data.issuer) + "</div></td></tr>";
                return tr;
            },
            yes() {
                doDeleteRemote(context.get("activityId"));
            }
        });
    }
    function doDeleteRemote(activityId) {
        return app.ajaxAuth({
            url: httpUtil.getApiUrl("/p2p/jobs/" + activityId + "?orderId=" + storage.getItem("orderId")),
            type: "delete",
            contentType: "application/json",
        }).then(() => {
            table.xuxDecoratedTable("reload");
        });
    }

    let tableSupport = new XuxTableSupport({
        elem: table,
        l10n: app.l10n,
        columns: {
            createdAt: {
                _localizationLabel: "instruction.label.issueDate",
                _defaultSort: true,
                contentEllipsis: true,
                defaultSortOrder: "desc",
                _sortByBeforeFormat: true,
                _formatter(value) {
                    return $.xux.formatDateTime(util.getDate(value), {seconds: true});
                }
            },
            activityType: {
                _localizationLabel: "instruction.label.instruction",
                contentEllipsis: true,
                defaultSortOrder: "asc",
                _formatter(value) {
                    let key;
                    if (value === "remoteBackup") {
                        key = window.localizedTextMessages.api.remoteBackup;
                    } else if (value === "remoteRestore") {
                        key = window.localizedTextMessages.api.remoteRestore;
                    } else if (value === "scheduledRemoteRestore") {
                        key = window.localizedTextMessages.api.scheduledInstall;
                    }
                    return key;
                }
            },
            displayName: {
                _localizationLabel: "instruction.label.issuedTo",
                contentEllipsis: true,
                defaultSortOrder: "asc"
            },
            userName: {
                _localizationLabel: "instruction.label.issuedBy",
                contentEllipsis: true,
                defaultSortOrder: "asc"
            },
            successful: {
                _hidden: true,
            },
            failed: {
                _hidden: true,
            },
            expired: {
                _hidden: true,
            },
            canceledByUser: {
                _hidden: true,
            },
            canceledBySystem: {
                _hidden: true,
            },
            downloaded: {
                _localizationLabel: "history.label.status",
                contentEllipsis: true,
                defaultSortOrder: "asc",
                _formatter(value) {
                    if (value) {
                        return window.localizedTextMessages.api.downloadedTrue;
                    } else {
                        return window.localizedTextMessages.api.downloadedFalse;
                    }
                }
            },
            activityId: {_hidden: true},
            action: {
                _localizationLabel: "com.label.blank",
                render(td, item) {
                    $("<span />").prop("class", "xux-icon xux-icon-wastebasket").appendTo(td).click(() => {
                        window.document.activeElement.blur();
                        deleteRemote(item);
                    });
                },
                _noQuery: true,
                width: "fitContent"
            }
        },
        supportOptions: {
            enableBrowserfilter: true,
            cachePagingMethod: "noPaging",
            fetch() {
                let url = tableSupport.createQueryUrl(
                    httpUtil.getApiUrl("/p2p/jobs") + "?timestemp=" + Date.now());
                return app.ajaxAuth({
                    url,
                    type: "get",
                    contentType: "application/json",
                    data: {
                        orderId: storage.getItem("orderId"),
                    }
                });
            }
        },
        xuxOptions: {
            columnResizable: true,
            pageNavigation: "none",
            sortOptions: {
                column: 0,
                order: "desc"
            },
            autoLoad: false,
            selectionUnit: "none"
        }});

    tableSupport.init();
    if (!app.session.tenant.isFXTenant || storage.getItem("orderId")) {
        $("#remote-table").xuxDecoratedTable("load");
    }
    $("#body").xuxPage({
        width: "full",
        loginout: true,
        itemStates: ["", "", "", "selected"]
    });
    if (!app.session.tenant.isFXTenant) {
        $(".orderIdDiv").xuxApplyBoxAndLayout().hide();
    }

    $(".orderIdDiv").xuxApplyBoxAndLayout({
        labelLayout: "leading",
        contentEllipsis: true
    });
    $("#orderid-update").click(() => {
        order.openOrderList(app);
    });
    $("header").xuxHeader("utilityLinks")
        .xuxUtilityLinks("option", "user", app.session.userName);
});

